var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 243,
    viewBox: "0 0 402 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.786 27.2173H41.3993C36.2934 27.2173 32.1543 31.2095 32.1543 36.1342V232.262C32.1543 237.186 36.2934 241.179 41.3993 241.179H370.786C375.892 241.179 380.031 237.186 380.031 232.262V36.1342C380.031 31.2095 375.892 27.2173 370.786 27.2173Z",
    fill: "url(#paint0_linear_7314_215282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3993 27.2173H370.786C375.887 27.2173 380.031 31.211 380.031 36.1342V48.2909H32.1543V36.1342C32.1543 31.2148 36.295 27.2173 41.3993 27.2173Z",
    fill: "#0066D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.747 38.5641C315.747 40.2064 314.369 41.5351 312.666 41.5351C310.964 41.5351 309.586 40.2064 309.586 38.5641C309.586 36.9218 310.964 35.593 312.666 35.593C314.369 35.593 315.747 36.9218 315.747 38.5641Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.122 38.5641C336.122 40.2064 334.744 41.5351 333.041 41.5351C331.339 41.5351 329.961 40.2064 329.961 38.5641C329.961 36.9218 331.339 35.593 333.041 35.593C334.744 35.593 336.122 36.9218 336.122 38.5641Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M353.418 41.5351C355.119 41.5351 356.499 40.205 356.499 38.5641C356.499 36.9232 355.119 35.593 353.418 35.593C351.717 35.593 350.338 36.9232 350.338 38.5641C350.338 40.205 351.717 41.5351 353.418 41.5351Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M311.225 63.4299H275.119V94.9807H311.225V63.4299Z",
    fill: "#CCE9FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.824 81.6296H99.3301V94.9808H134.824V81.6296Z",
    fill: "#CCE9FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.994 81.6296H143.5V94.9808H178.994V81.6296Z",
    fill: "#CCE9FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.16 81.6296H187.666V94.9808H223.16V81.6296Z",
    fill: "#CCE9FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M267.33 81.6296H231.836V94.9808H267.33V81.6296Z",
    fill: "#CCE9FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M354.517 81.6296H319.023V94.9808H354.517V81.6296Z",
    fill: "#CCE9FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M354.517 63.4299H319.023V76.7811H354.517V63.4299Z",
    fill: "#CCE9FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.537 63.4299H99.2012V76.2137H268.537V63.4299Z",
    fill: "#CCE9FA"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5365 68.857V92.2896C90.5365 93.581 89.4529 94.6261 88.114 94.6261H63.4362C62.0972 94.6261 61.0137 93.581 61.0137 92.2896V61.2613C61.0137 59.9699 62.0972 58.9248 63.4362 58.9248H80.2428L90.5404 68.857H90.5365Z",
    fill: "#33AB84"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2383 68.8571H90.5359L80.2383 58.9287V68.8571Z",
    fill: "#00805A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8228 73.9705H68.7715V87.5231H82.8228V73.9705Z",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7715 73.9705V87.5791",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8261 80.7749H68.7168",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M399.997 102.819H104.014V200.334H399.997V102.819Z",
    fill: "white",
    stroke: "#9BDBF7",
    strokeWidth: 2.98,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.873 141.972H251.825V161.508H177.873C177.873 161.508 177.927 141.778 177.873 141.972Z",
    fill: "#0D66D0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M325.99 161.269H399.942V180.805H325.99C325.99 180.805 326.044 161.075 325.99 161.269Z",
    fill: "#0D66D0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M399.998 122.321H104.016",
    stroke: "#9BDBF7",
    strokeWidth: 3.11,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M399.998 141.823H104.016",
    stroke: "#9BDBF7",
    strokeWidth: 3.11,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M399.998 161.329H104.016",
    stroke: "#9BDBF7",
    strokeWidth: 3.11,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M399.998 180.831H104.016",
    stroke: "#9BDBF7",
    strokeWidth: 3.11,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M326.002 200.334V102.819",
    stroke: "#9BDBF7",
    strokeWidth: 3.11,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M252.008 200.334V102.819",
    stroke: "#9BDBF7",
    strokeWidth: 3.11,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M178.012 200.334V102.819",
    stroke: "#9BDBF7",
    strokeWidth: 3.11,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M104.014 102.819H399.997V122.321H104.014C104.014 122.321 104.238 102.621 104.014 102.819Z",
    fill: "url(#paint1_linear_7314_215282)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M104.014 122.369H177.857V200.3H104.014C104.014 200.3 104.068 121.589 104.014 122.369Z",
    fill: "url(#paint2_linear_7314_215282)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M399.996 241.261H0V243H399.996V241.261Z",
    fill: "#378EF0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2867 136.646C23.6238 136.911 28.3837 145.597 30.1947 153.229C33.4996 165.218 31.584 180.753 36.5915 182.459C49.9463 186.385 45.6933 140.591 41.9899 138.494C40.2485 137.534 36.5335 136.971 33.2906 136.646H33.2867Z",
    fill: "#FFB09F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9938 178.476C32.6289 171.974 33.3293 215.286 35.8176 227.465C38.3059 239.644 40.9722 231.384 42.8374 211.938C44.7027 192.491 45.6779 181.033 41.9938 178.476Z",
    fill: "#FFB09F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3917 226.244L34.0859 230.787L41.8024 231.041L41.6243 226.636L34.3917 226.244Z",
    fill: "#FFB09F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9702 230.947C41.9702 230.947 43.4097 233.695 48.2277 237.304C53.0456 240.913 54.3226 240.155 54.4232 241.484C54.52 242.813 33.2012 241.458 33.2012 241.458L33.979 230.552C33.979 230.552 41.974 230.667 41.9702 230.951V230.947Z",
    fill: "#323232"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9692 136.773C13.5075 134.862 13.5153 144.719 13.4379 152.546C13.7629 164.95 10.6826 179.29 15.1406 182.07C27.1835 188.886 31.0997 141.89 28.0039 139.016C26.5411 137.691 26.0457 137.814 22.9692 136.773Z",
    fill: "#FFB09F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1969 178.271C10.832 171.769 11.5324 215.08 14.0207 227.26C16.509 239.439 19.1753 231.179 21.0406 211.732C22.9058 192.286 23.881 180.827 20.1969 178.271Z",
    fill: "#FFB09F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8529 227.409L12.7832 231.862L20.1862 231.989L20.1204 227.61L12.8529 227.409Z",
    fill: "#FFB09F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7104 231.798C12.5981 233.556 10.6323 239.558 10.5742 241.085C22.3385 241.484 21.9824 243.765 20.2062 231.907L12.7104 231.798Z",
    fill: "#323232"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.301 137.049C15.301 137.049 12.1587 142.182 12.2671 158.761C12.387 177.719 12.1665 182.164 12.151 183.56C12.1355 184.956 11.7988 228.249 11.7988 228.249C11.7988 228.249 19.1399 229.772 20.9239 228.32C21.8603 227.559 29.5845 159.456 29.5845 159.456C29.5845 159.456 31.0047 175.621 31.4188 181.753C31.7787 187.061 31.5155 223.513 33.4621 227.26C35.4937 228.88 42.9431 228.115 43.0437 228.014C44.1544 226.898 47.8423 152.035 44.4175 138.326L15.301 137.046V137.049Z",
    fill: "#00335A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1534 96.1077C32.8401 99.3811 39.6858 130.17 43.784 128.558C50.9547 129.092 47.7738 92.5059 38.1534 96.1077Z",
    fill: "#FFB09F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1074 91.2629C46.8282 93.0471 46.4257 105.506 47.6215 114.397L37.293 115.748L32.1074 91.2629Z",
    fill: "#0066D3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1235 129.226C50.3113 128.211 64.8077 103.755 63.4068 102.311C62.3232 99.5824 31.9452 129.196 44.1235 129.226Z",
    fill: "#FFB09F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9044 90.1953C3.16063 92.6177 16.9797 103.632 14.6269 137.415C14.6037 139.83 44.7805 140.983 44.6373 138.471C41.3596 111.825 50.8716 94.3421 32.0798 91.0874",
    fill: "#0066D3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1232 88.6202L32.0729 93.6479C31.6511 98.2724 24.1398 93.2784 23.3001 91.3823C22.7196 90.1618 23.5787 89.5422 23.6058 86.9667C23.6329 84.3913 23.6367 84.1076 23.6367 84.1076C14.6665 70.3609 29.6272 64.7659 35.3507 74.5189C35.3662 82.4728 37.51 89.9751 32.1271 88.624L32.1232 88.6202Z",
    fill: "#FFB09F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6135 95.6895C6.75843 97.4587 4.39785 129.469 8.67399 128.961C15.2643 131.23 22.6053 94.6742 12.6135 95.6895Z",
    fill: "#FFB09F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4016 128.524L15.0602 125.374L17.9046 112.366L7.07681 111.135C7.07681 111.135 4.80909 128.599 8.03652 132.055C11.2601 135.511 33.496 134.84 33.496 134.84L34.4016 128.524Z",
    fill: "#FFB09F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15258 129.819C9.21837 130.883 9.94203 131.816 10.925 132.309C18.6027 136.142 51.7399 135.239 50.7067 133.033C50.6757 131.316 8.66886 121.813 9.15258 129.819Z",
    fill: "#FFB09F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0869 90.1953C23.0869 90.1953 12.4991 90.6246 10.4055 93.8942C8.31197 97.1639 6.38867 111.62 6.38867 111.62L17.8782 112.855L19.0584 106.424",
    fill: "#0066D3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4856 68.6961C36.6736 69.2374 37.3779 70.4541 37.2889 71.7194C37.1651 73.4625 36.6001 75.855 34.433 75.6498C31.0469 75.3288 27.6763 73.7537 26.5115 75.0376C25.3428 76.3179 26.4921 84.1561 28.0942 84.0665C29.6963 83.9732 35.8416 82.5176 36.0119 83.7418C36.186 84.9661 36.7781 90.2177 34.3169 90.6992C31.8557 91.1769 27.297 89.2696 26.4921 87.646C25.6911 86.0224 25.3931 84.1001 25.3157 82.5885C25.2383 81.0805 24.9249 78.7963 23.791 78.8411C22.6533 78.8858 23.8413 84.0628 23.6362 84.1113C23.4311 84.1636 20.2114 79.4159 20.641 75.5975C21.0705 71.7792 21.6936 69.0731 26.2367 68.8641C29.9247 68.6961 32.8425 67.5017 35.4856 68.7036V68.6961Z",
    fill: "#2E2E2E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0266 129.849L34.5352 129.595L34.5223 130.841L61.0137 131.096L61.0266 129.849Z",
    fill: "#00338C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9593 131.156L43.3047 130.921L50.4251 114.778L75.0797 115.013L67.9593 131.156Z",
    fill: "#00338C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6527 131.16L44.002 130.924L51.1224 114.785L75.777 115.017L68.6527 131.16Z",
    fill: "url(#paint3_linear_7314_215282)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8523 123.795C61.3957 124.863 60.4321 125.49 59.7007 125.199C58.9693 124.908 58.7448 123.807 59.2015 122.739C59.6581 121.672 60.6217 121.045 61.3531 121.336C62.0845 121.627 62.3089 122.728 61.8523 123.795Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9921 100.549C66.2436 101.568 67.6019 102.262 66.499 104.196C65.3961 106.129 61.7237 106.607 61.7237 106.607L60.1719 103.912C60.1719 103.912 60.7717 103.14 60.8839 102.651C60.9961 102.165 61.7082 100.4 63.5386 99.6086C65.369 98.8173 68.2366 97.9962 68.5965 98.515C68.9525 99.0338 65.7986 99.7505 65.9959 100.549H65.9921Z",
    fill: "#FFB09F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6177 131.35L45.2539 131.1L46.1169 130.57H46.1246L47.6648 129.719C48.0595 129.502 48.5007 129.383 48.9535 129.372L50.9154 129.786C50.9154 129.786 51.256 130.286 50.1144 130.331C49.8164 130.342 49.4217 130.6 49.1121 130.827L50.2382 130.928L52.9742 131.376C53.6746 131.484 54.4486 132.163 54.348 132.97C54.348 132.97 54.1119 134.089 52.8078 134.392L51.0315 134.963C50.0602 135.105 49.3327 135.388 48.3807 135.153L45.8421 134.298L45.6177 131.354V131.35Z",
    fill: "#FFB09F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M217.623 58.0311C234.011 58.0311 247.297 45.2171 247.297 29.4103C247.297 13.6035 234.011 0.789551 217.623 0.789551C201.235 0.789551 187.949 13.6035 187.949 29.4103C187.949 45.2171 201.235 58.0311 217.623 58.0311Z",
    fill: "#378EF0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M201.987 33.1914C201.987 32.6688 201.802 32.2023 201.461 31.8776C201.148 31.579 200.737 31.4185 200.273 31.4185H200.265C199.286 31.4185 198.574 32.1575 198.574 33.1727C198.574 37.0695 198.574 40.9624 198.574 44.8592C198.574 45.0533 198.574 45.2548 198.625 45.4228C198.899 46.4641 199.82 46.6843 200.548 46.6843C211.921 46.6843 223.295 46.6843 234.668 46.6843C235.995 46.6843 236.673 46.0312 236.673 44.7435C236.673 42.81 236.673 40.8766 236.673 38.9432V36.5133C236.676 35.3898 236.68 34.2663 236.673 33.1429C236.669 32.5905 236.444 32.109 236.046 31.7917C235.651 31.4782 235.132 31.3625 234.583 31.4595C233.762 31.6088 233.248 32.2956 233.248 33.2586C233.248 35.2853 233.248 37.3121 233.248 39.3388V42.3808C233.248 43.1833 233.062 43.3662 232.245 43.3662C222.486 43.3662 212.722 43.3662 202.963 43.3662C202.839 43.3662 202.715 43.3587 202.583 43.3512L201.999 43.3176V39.8352C201.999 37.6181 201.999 35.401 201.999 33.1877L201.987 33.1914Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M217.609 38.1258C217.13 38.1258 216.421 37.9391 215.756 37.0545L213.414 33.9454C211.936 31.9784 210.454 30.0113 208.972 28.048C208.391 27.2791 208.291 26.5214 208.67 25.7899C209.057 25.0471 209.746 24.6888 210.752 24.6813C211.824 24.6888 212.892 24.6851 213.96 24.6813H214.115V21.9529C214.115 19.0453 214.115 16.1339 214.119 13.2263C214.119 11.808 214.846 10.7106 216.162 10.1321C217.451 9.56473 218.77 9.73643 219.877 10.6173C220.705 11.2779 221.123 12.1961 221.115 13.342C221.112 14.3125 221.115 15.2792 221.115 16.2459V24.6776H221.522C222.505 24.6776 223.488 24.6813 224.471 24.6776H224.498C225.492 24.6776 226.185 25.0508 226.56 25.7824C226.939 26.5289 226.835 27.2978 226.247 28.0742C224.73 30.0822 223.217 32.0903 221.704 34.0984L219.486 37.0433C218.813 37.9354 218.101 38.122 217.621 38.122L217.609 38.1258Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7314_215282",
    x1: 32.1543,
    y1: 134.198,
    x2: 380.031,
    y2: 134.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE9FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7314_215282",
    x1: 104.014,
    y1: 112.568,
    x2: 399.997,
    y2: 112.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7314_215282",
    x1: -17.4405,
    y1: 161.333,
    x2: 177.857,
    y2: 161.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7314_215282",
    x1: 75.7731,
    y1: 122.971,
    x2: 44.002,
    y2: 122.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06449B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004AA9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState3);
export default __webpack_public_path__ + "static/media/empty-state-3.5666917980208711ff8e887f92446862.svg";
export { ForwardRef as ReactComponent };